export default __webpack_public_path__ + "static/media/O-080.f6854c3e.png";